module.exports = {
          srcSet: __webpack_public_path__ + "021600f49e545641c4d633b3ff4ce0dc-488.png"+" 488w",
          images:[ {path: __webpack_public_path__ + "021600f49e545641c4d633b3ff4ce0dc-488.png",width: 488,height: 489}],
          src: __webpack_public_path__ + "021600f49e545641c4d633b3ff4ce0dc-488.png",
          toString:function(){return __webpack_public_path__ + "021600f49e545641c4d633b3ff4ce0dc-488.png"},
          
          width: 488,
          height: 489
        }